export const QRCODE_TYPES = ['canvas', 'image'] as const;

export type QrcodeTypes = typeof QRCODE_TYPES[number];
